module.exports = __webpack_public_path__ + "img/longqi_edu_logo.934cb1c2.jpeg";